import audienceBuilder from './audienceBuilder';
import campaignsTable from './campaignsTable.actions';
import { WorkerAction } from '../framework/workerAction';

export default {
  audienceBuilder,
  lastVisitedURL: new WorkerAction({ name: 'Actions.front.lastVisitedURL' }, {}),
  initLoading: new WorkerAction({ name: 'FRONT_INIT_LOADING' }, {}),
  campaignsTable,
};
